import { Data2, newId, dateToString } from '../../../features/data-types'
import { Currency } from '../../../tables/types/types'
import { Item } from '../../operations'
import { useSystemStateHooks } from '../../system'
import { Budget } from '../state/types'

export const useBudgetBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildBudget = (data: Data2) => {
        const {
            id = newId(),
            code,
            items,
            date,
            sellerId,
            customerId,
            customerTypeId,
            currency,
            archived
        } = data

        const budget: Budget = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            items: (items || []) as Item[],
            date: dateToString(date)!,
            sellerId: sellerId! as string,
            customerId: customerId! as string,
            customerTypeId: customerTypeId! as string,
            currency: (currency || Currency.ARS) as Currency,
            archived: !!archived
        }

        return budget
    }

    return {
        buildBudget
    }
}
